// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3FDXiJMUot4UzUGzZTYqKw\\=\\={height:100vh}", "",{"version":3,"sources":["webpack://./components/layouts/FullPageLoader/styles.module.scss"],"names":[],"mappings":"AAAA,6BACI,YAAA","sourcesContent":[".wrapper {\n    height: 100vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "_3FDXiJMUot4UzUGzZTYqKw=="
};
export default ___CSS_LOADER_EXPORT___;
